import { useEffect, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { checkSelectedActiveColumn } from '../../../utils/market-development';
import { calculateSPLOCIRatioCells } from '../../../utils/ews-sploci-utils';
import Spreadsheet from 'react-spreadsheet';
import EWSLabels from './ews-template-labels';
import { formatEWS } from '../../../utils/formatEWS';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

export default function EWSSPLOCIRATIO({ readOnly = false, code = null, labels = [], cells = [], onChange = ({ code, cells }) => null }) {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const year = Number(urlParams.get('year')) || null;
	const [dataCells, setDataCells] = useState([]);
	const [active, setActive] = useState(null);

	useEffect(() => {
		const highlightedRows = new Set([2, 8, 10, 18, 25, 32, 37, 43, 45, 47, 54, 56]);
		const normalizeRow = (row = []) => {
			const r = [...row];
			for (let i = 0; i < 3; i++) r[i] = r[i] ?? { value: '' };
			return r;
		};

		setDataCells(
			(cells || []).map((row, rowIndex) => {
				const r = normalizeRow(row);
				return r.map((cell, colIndex) => {
					const isSum = highlightedRows.has(rowIndex);
					const formatted = isSum ? formatEWS(cell.value) : cell.value;
					return {
						...cell,
						value: formatted,
						className: isSum ? 'highlighted-row' : '',
					};
				});
			})
		);
	}, [cells]);

	return (
		<>
			<Box>
				<Text fontSize="large" fontWeight="bold" mb={4}>
					{t('Statement of Profit or Loss and Other Comprehensive Income')}
				</Text>
				<Box className="ews-container">
					<div className="ews-1-row-head-data" />
					<table className="spreadsheet_custom_header">
						<thead>
							<tr style={{ height: '50px' }}>
								<>
									<th
										className={checkSelectedActiveColumn(active) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year}
									</th>
									<th
										className={checkSelectedActiveColumn(active) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year - 1}
									</th>
									<th
										className={checkSelectedActiveColumn(active) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year - 2}
									</th>
								</>
							</tr>
							<tr style={{ height: '34px' }}>
								<td className={checkSelectedActiveColumn(active, 0) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
								<td className={checkSelectedActiveColumn(active, 1) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
								<td className={checkSelectedActiveColumn(active, 2) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
							</tr>
						</thead>
					</table>

					<div>
						<EWSLabels type="EWS" labels={labels} active={active} />
						<Box>
							<Flex alignItems="center" mt="0px" h="0px" borderRight="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2} />
							<Spreadsheet
								data={dataCells}
								onChange={(dataCells) => {
									if (readOnly) {
										onChange({
											code,
											cells: cells?.reduce((pre, cur, i) => {
												let localPre = pre;
												localPre.push([{ value: cur[0]?.value, readOnly: true }]);
												return localPre;
											}, []),
										});
									} else {
										onChange(calculateSPLOCIRatioCells({ code, cells: dataCells, numLabel: labels?.length }));
									}
								}}
								onActivate={(e) => setActive({ ...e, t: 'EWS' })}
								hideRowIndicators
								hideColumnIndicators
							/>
						</Box>
					</div>
				</Box>
			</Box>
		</>
	);
}
